"use client";
import { useLanguage } from "../../translations/LocalizationProvider.js";
import { addNecessityIndicator } from "../validation/validation.js";
import { useForm } from "./formContext.js";
function useFormProps(originalProps, getChangedValue) {
  const lang = useLanguage();
  const formCtx = useForm();
  if (!formCtx || !originalProps.field) {
    return originalProps;
  }
  const { id: formId, form } = formCtx;
  const formProps = form.inputProps(originalProps.field);
  const props = formProps ? {
    ...originalProps,
    id: originalProps.id ?? `${formId}_${String(originalProps.field)}`,
    helperText: addNecessityIndicator(form.state.raw, form.validationConfig.validators, form.validationConfig.options.showNecessityOn, lang, originalProps.helperText, originalProps.field),
    onChange: (event) => {
      var _a;
      (_a = originalProps.onChange) == null ? void 0 : _a.call(originalProps, event);
      formProps.setValue(getChangedValue(event));
    },
    onBlur: (event) => {
      var _a;
      (_a = originalProps.onBlur) == null ? void 0 : _a.call(originalProps, event);
      formProps.onBlur();
    },
    value: formProps.value,
    validity: formProps.validity ?? originalProps.validity
  } : originalProps;
  return props;
}
export {
  useFormProps
};
